import React from 'react'
import { connect } from 'react-redux'
import '../css/styles.css';

import { PENDING, NEGATIVE, POSITIVE, EQUIVOCAL, NORESULT, CANCELLED, INVALID } from '../api/mappers/labResultMapper'

import PositiveImportantInfo from '../components/positiveImportantInfo';
import NegativeImportantInfo from '../components/negativeImportantInfo';
import EquivocalImportantInfo from '../components/equivocalImportantInfo';
import NoResultImportantInfo from '../components/noResultImportantInfo';
import CancelledImportantInfo from '../components/cancelledImportantInfo';
import InvalidImportantInfo from '../components/invalidImportantInfo';

const Header = (props) => {
    const { selectedResult, strings } = props;
    if (!selectedResult) return null;

    switch (selectedResult.result) {
        case POSITIVE:
            return <h5><b class="info-header">{strings.IMPORTANT_POSITIVE_MESSAGE_1}</b><b>{strings.IMPORTANT_POSITIVE_MESSAGE_2}</b></h5>
        case NEGATIVE:
            return <h4 class="alert-heading info-header">{strings.IMPORTANT_NEGATIVE_INFO_HEADER}</h4>
        default:
            return <h4 class="alert-headering">{strings.IMPORTANT_INFO_HEADER}</h4>

    }
}

const Body = (props) => {
    const { selectedResult } = props;
    if (!selectedResult) return null;

    switch (selectedResult.result) {
        case POSITIVE:
            return <PositiveImportantInfo />
        case NEGATIVE:
            return <NegativeImportantInfo />
        case PENDING:
            return <NoResultImportantInfo />
        case NORESULT:
            return <NoResultImportantInfo />
        case EQUIVOCAL:
            return <EquivocalImportantInfo />
        case CANCELLED:
            return <CancelledImportantInfo />
        case INVALID:
            return <InvalidImportantInfo />
        default:
            return null;
    }
}

const ImportantInfo = (props) => {
    const { selectedResult, strings, isModal } = props;

    if (isModal === false) {
        return (
            <div class={"alert alert-success"} role="alert">
                <Header selectedResult={selectedResult} strings={strings} />
                <br />
                <Body selectedResult={selectedResult} />
            </div>
        );
    } else {
        return <Body selectedResult={selectedResult} />
    }
}

const mapStateToProps = (state) => {
    return {
        strings: state.language.strings
    }
}

const ConnectedImportantInfo = connect(
    mapStateToProps
)(ImportantInfo);
export default ConnectedImportantInfo;
